import { Selector } from '@ngxs/store';
import { AppMainSelector } from '../app-main.selector';
import { AppState } from '@state/app/app.state';
import { SideNavFlyoutType } from '@state/app/app.model';

export interface NavbarState {
	showSideNav: boolean;
	loadedFromLeap: boolean;
	sideNavFlyOut: SideNavFlyoutType;
}

export class NavbarSelectors {
	@Selector([
		AppMainSelector.ShowSideNav,
		AppState.loadedFromLeap,
		AppState.sideNavFlyOut,
	])
	static getNavbarState(
		showSideNav: boolean,
		loadedFromLeap: boolean,
		sideNavFlyOut: SideNavFlyoutType,
	): NavbarState {
		return {
			showSideNav,
			loadedFromLeap: loadedFromLeap,
			sideNavFlyOut,
		};
	}
}
